import React, { forwardRef } from 'react';

import { Input } from 'antd';
const { Password } = Input;
const BaseColumnPassword = (props) => {
  const { label, inputStyle, labelStyle, readonly, width, ...rest } = props;

  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      height: '5.8rem',
      // font
      fontFamily: 'Public Sans',
      fontStyle: 'normal',
    },
    label: {
      display: 'flex',
      height: '2rem',
      alignItems: 'center',
      // font
      fontWeight: 400,
      fontSize: '1.3rem',
      lineHeight: '1.5rem',
      // color: 'black',
    },
    text: {
      display: 'flex',
      alignItems: 'center',
      height: '3.8rem',
      width: '100%',
      padding: '0rem 1rem 0rem 1rem',
      background: 'transparent',
      border: '1px solid #DBDADE',
      borderRadius: 6,

      // font
      fontFamily: 'Public Sans',
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '1.3rem',
      lineHeight: '1.5rem',
    },
  };

  return (
    <div style={{ ...styles.container }}>
      <div style={{ ...styles.label, ...labelStyle }}>{label}</div>
      <Password style={{ ...inputStyle }} readOnly={readonly} {...rest} />
    </div>
  );
};

export default forwardRef(BaseColumnPassword);
